<template>
    <section
        :id="`element-${settings.id}`"
        class="elle-folders padd-v"
        :class="{ 'f-screen': settings?.fullScreen }"
        :style="{ backgroundColor: settings?.color }"
    >
        <div class="container">
            <div class="grid12">
                <div class="l-col">
                    <UiHeadline
                        :settings="{
                            label: settings?.label,
                            headline: settings?.headline
                        }"
                    >
                        <template #additional>
                            <FormsSearch v-if="settings.search" @change-query="text => (query = text)" />
                            <FormsToggleFilter v-if="settings.filter" :tags="tags" @on-change-filter="id => onChangeFilter(id)" />
                        </template>
                    </UiHeadline>
                </div>
                <div class="r-col">
                    <LoopsFolders :items="filteredItems" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { FormsSearch } from '#components';
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        settings?: CmsItem;
    }>(),
    {
        settings: () => ({})
    }
);

const { $ScrollTrigger: ScrollTrigger } = useNuxtApp();

const currentFilter = ref(-1);
const query = ref('');
const settings = computed(() => props.settings);

const tags = computed<CmsItem[]>(() => {
    const values: CmsItem[] = [];
    if (!settings.value?.folderList?.length) return values;

    settings.value.folderList.forEach((item: CmsItem) => {
        if (item.folderGroup.length) {
            values.push(...item.folderGroup);
        }
    });

    values.sort((a, b) => {
        const titleA = String(a.title ?? '');
        const titleB = String(b.title ?? '');
        if (titleA < titleB) return -1;
        if (titleA > titleB) return 1;
        return 0;
    });

    return [...new Map(values.map(item => [item.id, item])).values()];
});

const filteredItems = computed<CmsItem[]>(() =>
    (settings.value?.folderList ?? []).filter((item: CmsItem) => {
        const included =
            query.value.toLocaleLowerCase() !== ''
                ? String(item.title ?? '')
                      .toLowerCase()
                      .includes(query.value.toLocaleLowerCase()) ||
                  String(item.body ?? '')
                      .toLowerCase()
                      .includes(query.value.toLocaleLowerCase())
                : true;
        const grouped = currentFilter.value !== -1 ? item.folderGroup.filter((group: CmsItem) => group.id == currentFilter.value).length : true;

        return included && grouped;
    })
);

const onChangeFilter = (id: number) => {
    currentFilter.value = id;
    nextTick(() => ScrollTrigger.refresh(true));
};
</script>
